module.exports = __webpack_public_path__ + "static/media/carousel_img4.3bc51f29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/carousel_img4.png
// module id = 366
// module chunks = 0